var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":"10vw","direction":"vertical","autoplay":true,"indicator-position":"none"}},_vm._l((_vm.ads),function(url,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":_vm.imgUrl?.url.replace(/\/$/, '')+url,"alt":url}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }